<template>
  <el-button type="text" icon="el-icon-download" :loading="isPreparing" @click="startDownload">
    下载
  </el-button>
</template>

<script>
import { downloadFile } from '@/api/file'

export default {
  name: 'FileDownloadWithProgress',
  props: {
    fileId: { type: [Number, String], required: true },
    fileName: { type: String, required: true },
    fileSize: { type: Number, default: 0 }
  },
  data() {
    return { isPreparing: false }
  },
  methods: {
    async startDownload() {
      if (this.isPreparing) return
      this.isPreparing = true
      try {
        await downloadFile(this.fileId, this.fileName)
        this.$message.success('已交由浏览器下载，请查看浏览器下载列表')
      } catch (error) {
        this.$message.error(error.message || '获取下载链接失败')
      } finally {
        this.isPreparing = false
      }
    }
  }
}
</script>
